import { render, staticRenderFns } from "./ComentarioCard.vue?vue&type=template&id=40edade1&"
import script from "./ComentarioCard.vue?vue&type=script&lang=js&"
export * from "./ComentarioCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports